export default "__VITE_ASSET__C3WYserL__"